export default __webpack_public_path__ + "assets/log.ced612ef.svg";